"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setPathValue = exports.createRequiredContainers = void 0;
const valueConfig_1 = require("./valueConfig");
const checkContainerType = (type) => type === 'array' || type === 'object';
const checkArrayContainer = (value) => (value !== null && typeof value === 'object' && Array.isArray(value));
const checkObjectContainer = (value) => (value !== null && typeof value === 'object' && !Array.isArray(value));
const createContainer = (type, prevValue) => {
    if (type === 'array') {
        if (checkArrayContainer(prevValue)) {
            return [...prevValue];
        }
        return [];
    }
    if (type === 'object') {
        if (checkObjectContainer(prevValue)) {
            return { ...prevValue };
        }
        return {};
    }
    return undefined;
};
/**
 * zodSchema.safeParse(undefined) => [{ path: [], error: 'required' }] \
 * zodSchema.safeParse({}) => [{ path: ['a'], error: 'invalidA' }, { path: ['b'], error: 'invalidB' }]
 * ToDo: But if field is object or array and filed is required, that we don't display error. Fix it.
 * */
const createRequiredContainers = (value, valueConfig) => {
    if (!checkContainerType(valueConfig === null || valueConfig === void 0 ? void 0 : valueConfig.type))
        return value;
    if (!valueConfig || valueConfig.optional)
        return value;
    const result = createContainer(valueConfig === null || valueConfig === void 0 ? void 0 : valueConfig.type, value);
    const createShapeTasks = (targetConfig, container) => {
        var _a;
        return (Object.entries((_a = targetConfig.shape) !== null && _a !== void 0 ? _a : {}).map(([key, config]) => {
            return {
                key,
                config,
                container,
            };
        }));
    };
    const tasks = createShapeTasks(valueConfig, result);
    while (tasks.length > 0) {
        const task = tasks.pop();
        if (!task)
            continue;
        const { key, config, container } = task;
        if (!config || config.optional)
            continue;
        if (!container)
            continue;
        if (!checkContainerType(config.type))
            continue;
        if (config.skipValidation)
            continue;
        container[key] = createContainer(config.type, container[task.key]);
        const nextContainer = container[key];
        tasks.push(...createShapeTasks(config, nextContainer));
    }
    return result;
};
exports.createRequiredContainers = createRequiredContainers;
/** Recreate new value with pathValue and copy prev value */
const setPathValue = (value, config, path, pathValue) => {
    const simplePath = path;
    if (simplePath.length === 0)
        return pathValue;
    const result = createContainer(config === null || config === void 0 ? void 0 : config.type, value);
    let tmpConfig = config;
    let tmpResult = result;
    simplePath.forEach((key, index) => {
        if (!tmpResult)
            return;
        if (simplePath.length === index + 1) {
            tmpResult[key] = pathValue;
            return;
        }
        tmpConfig = (0, valueConfig_1.getPathValueConfig)(tmpConfig, [key]);
        tmpResult[key] = createContainer(tmpConfig === null || tmpConfig === void 0 ? void 0 : tmpConfig.type, tmpResult[key]);
        tmpResult = tmpResult[key];
    });
    return result;
};
exports.setPathValue = setPathValue;
//# sourceMappingURL=setPathValue.js.map